import store from '@/store';

const userLang = store.state.user.userInfo.lang;

export function i18nNumber(n_images) {
  if (!userLang) {
    return n_images;
  }
  return new Intl.NumberFormat(userLang).format(n_images);
}

function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function isRange(min, max) {
  return min.toString() !== max.toString();
}

function isMonthDayRange(min, max) {
  const date_min = new Date(min);
  const date_max = new Date(max);
  return (date_min.getMonth === date_max.getMonth) && (date_min.getDay === date_max.getDay);
}

function isMonthRange(min, max) {
  return isRange(getYearMonth(min), getYearMonth(max));
}

export function isYearRange(min, max) {
  return isRange(getYear(min), getYear(max));
}

function isRangeMonthDayValid(min, max) {
  const date_min = new Date(min);
  const date_max = new Date(max);
  const isMinFirstDayYear = date_min.getMonth() === 0 && date_min.getDate() === 1; // 1 January
  const isMaxLastDayYear = date_max.getMonth() === 11 && date_max.getDate() === 31; // 31 December

  return (!isMinFirstDayYear && !isMaxLastDayYear) || !isMonthDayRange(min, max); // 2: different year but same month/day (like impossible)
}

function isRangeMonthExtend(min, max) {
  const date_min = new Date(min);
  const date_max = new Date(max);
  const lastDayMaxMonth = new Date(date_max.getFullYear(), date_max.getMonth() + 1, 0);

  const sameMonth = date_min.getMonth() === date_max.getMonth();
  const isMinFirstDay = date_min.getDate() === 1;
  const isMaxLastDay = date_max.getDate() === lastDayMaxMonth.getDate() || date_max.getDate() === lastDayMaxMonth.getDate() - 1; // Some date might be wrong

  return sameMonth && isMinFirstDay && isMaxLastDay;
}

export function getYear(fullDate) {
  let fullYear = '';
  if (fullDate) {
    const date = new Date(fullDate);
    fullYear = date.getFullYear();
  }
  return fullYear;
}

export function getYearMonth(fullDate) {
  const date = new Date(fullDate);
  const newDate = new Date(date.getFullYear(), date.getMonth());
  return capitalize(newDate.toLocaleDateString(userLang, { month: 'long', year: 'numeric' }));
}

export function getDateYearString(min, separator, max) {
  let date = '';
  if (!min && !max) {
    date = '';
  }
  if (min && !max) {
    date = getYear(min);
  }
  else if (!min && max) {
    date = getYear(max);
  }
  else if (isYearRange(min, max)) {
    date = getYear(min) + separator + getYear(max);
  }
  else {
    date = getYear(min);
  }
  return date;
}

export function getLocalDateString(strISOdate, lang) {
  return new Date(strISOdate).toLocaleDateString(lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function getDisplayDates(min, max) {
  // Exact Date Range, return one date with formatting
  if (min && max && !isRange(min, max)) {
    const date_min = new Date(min);
    return [date_min.toLocaleDateString(userLang, { day: 'numeric', month: 'long', year: 'numeric' })];
  }

  // Strip Month/day if they are the same (+ others issues)
  if (!isRangeMonthDayValid(min, max)) {
    return !isYearRange(min, max)
      ? [getYear(min)]
      : [getYear(min), getYear(max)];
  }
  // Strip day if the range is the whole month
  if (isRangeMonthExtend(min, max)) {
    return !isMonthRange(min, max)
      ? [getYearMonth(min)]
      : [getYearMonth(min), getYearMonth(max)];
  }

  // Nothing to strip but formatting is needed
  const date_min = new Date(min);
  const date_max = new Date(max);
  return [date_min.toLocaleDateString(userLang, { day: 'numeric', month: 'long', year: 'numeric' }),
  date_max.toLocaleDateString(userLang, { day: 'numeric', month: 'long', year: 'numeric' })];
}
